import { connect }          from 'react-redux';
import {
    toggleView, LIST_VIEW } from './../actions/ViewAction';
import SwitchView           from '../components/SwitchView';

const mapStateToProps = (state) => {
    return {
        viewType: state.view.placesView,
        theme   : state.assets.items.theme,
        show    : (null !== state.filter.selected && 0 < state.filter.selected.places.length),
        geo     : state.geo,
        map     : state.map
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleView: () => {
            return dispatch(toggleView());
        },
        isList: (viewType) => {
            return (LIST_VIEW === viewType);
        }
    }
};

const SwitchViewContainer = connect(mapStateToProps, mapDispatchToProps)(SwitchView);

export default SwitchViewContainer;


// WEBPACK FOOTER //
// ./src/containers/SwitchViewContainer.js